import { useI18n } from '../../../i18n'
import { pressureBadgeClass, pressureColor, type PressureBand } from '../../../utils/operationalUx'
import type { UnifiedPressure } from '../../../types/unifiedExecutiveContext'
import styles from '../../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  pressure: UnifiedPressure | null
  density?: 'compact' | 'full'
  showValue?: boolean
}

export default function OperationalPressureIndicators({
  pressure,
  density = 'full',
  showValue = true,
}: Props) {
  const { t } = useI18n()
  if (!pressure?.band) {
    return (
      <span className={styles.emptyState}>
        {t('enterpriseOperationalUx.context.noPressure', 'No operational pressure signal')}
      </span>
    )
  }
  const band = String(pressure.band).toUpperCase() as PressureBand
  return (
    <div className={density === 'compact' ? styles.metricRow : styles.postureMetric} data-density={density}>
      {density === 'full' ? (
        <p className={styles.postureMetricLabel}>
          {t('enterpriseOperationalUx.systemPressure', 'System pressure')}
        </p>
      ) : (
        <dt>{t('enterpriseOperationalUx.systemPressure', 'System pressure')}</dt>
      )}
      {density === 'compact' ? (
        <dd>
          <span className={pressureBadgeClass(band, styles)}>{band}</span>
          {showValue ? (
            <span style={{ marginLeft: 8, color: pressureColor(band) }}>{pressure.value}</span>
          ) : null}
        </dd>
      ) : (
        <p className={styles.postureMetricValue} style={{ color: pressureColor(band) }}>
          <span className={pressureBadgeClass(band, styles)} style={{ marginRight: 8 }}>
            {band}
          </span>
          {showValue ? pressure.value : null}
        </p>
      )}
    </div>
  )
}
